// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"230":"component---src-pages-index-jsx","883":"component---src-pages-404-js"}[chunkId] || chunkId) + "-" + {"230":"e015edf59e53b85d3c6a","731":"b8e13b13ff5d03a7bc34","843":"fba81f4545072ae16434","883":"f6d8d4106c9c76961681"}[chunkId] + ".js";
};